// src/index.js — adds REACT_APP_AGENT_ENDPOINT to runtime config
import React from "react";
import ReactDOM from "react-dom/client";
import './index.css';
import App from "./App";
import reportWebVitals from './reportWebVitals';
import { GoogleOAuthProvider } from "@react-oauth/google";

// Carga dinámica de configuración antes de renderizar la app
fetch("/config.json")
    .then((res) => res.json())
    .then((config) => {
        // Almacenar las variables necesarias como globales
        window.REACT_APP_API_ENDPOINT = config.REACT_APP_API_ENDPOINT;
        window.REACT_APP_FRONTEND_ENDPOINT = config.REACT_APP_FRONTEND_ENDPOINT;
        window.REACT_APP_GOOGLE_CLIENT_ID = config.REACT_APP_GOOGLE_CLIENT_ID;
        window.MAPBOX_TOKEN = config.MAPBOX_TOKEN;
        window.REACT_APP_AGENT_ENDPOINT = config.REACT_APP_AGENT_ENDPOINT;
        const root = ReactDOM.createRoot(document.getElementById("root"));
        root.render(
            <GoogleOAuthProvider clientId={window.REACT_APP_GOOGLE_CLIENT_ID}>
                <App />
            </GoogleOAuthProvider>
        );
    })
    .catch((err) => {
        console.error("❌ Error cargando config.json", err);
        const root = ReactDOM.createRoot(document.getElementById("root"));
        root.render(<div>Error cargando configuración</div>);
    });

// Puedes seguir registrando performance
reportWebVitals();
